import type { HotStreakState } from '@flip7/shared';
import { getLifeOutcome } from '@flip7/shared';

interface Props {
  state: HotStreakState;
  playerId: string | null;
}

export function HotStreakGameOver({ state, playerId }: Props) {
  const sorted = [...state.players].sort((a, b) => b.money - a.money);
  const myPlayer = state.players.find((p) => p.id === playerId);

  return (
    <div className="hs-game-over">
      <h2>Final Results</h2>

      {/* Standings */}
      <div className="hs-standings">
        {sorted.map((player, i) => {
          const isYou = player.id === playerId;
          return (
            <div key={player.id} className={`hs-standing-row ${isYou ? 'hs-standing-you' : ''}`}>
              <span className="hs-standing-rank">#{i + 1}</span>
              <span className="hs-standing-name">{player.name}{isYou ? ' (You)' : ''}</span>
              <span className="hs-standing-money">${player.money}</span>
            </div>
          );
        })}
      </div>

      {/* Life Outcome */}
      {myPlayer && (
        <div className="hs-life-outcome">
          <h3>Your Life Outcome</h3>
          <p className="hs-life-outcome-text">${myPlayer.money}: {getLifeOutcome(myPlayer.money)}</p>
        </div>
      )}
    </div>
  );
}
